var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CA35C02D-FB8D-4FF0-8BB4-93B20B29F362@0.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navic-GoSend---Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.5-Details---On-hold",
    transform: "translate(-18.000000, -605.000000)",
    fill: "#00880D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card",
    transform: "translate(0.000000, 96.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status",
    transform: "translate(0.000000, 399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List",
    transform: "translate(16.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "label/24/ic_correct",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.729,9.687 L11.093,15.685 C10.73,16.07 10.129,16.106 9.723,15.767 L7.348,13.78 C6.93,13.419 6.882,12.787 7.243,12.368 C7.603,11.949 8.234,11.901 8.653,12.262 L10.261,13.647 L15.272,8.315 C15.651,7.911 16.284,7.894 16.686,8.271 C17.088,8.651 17.107,9.285 16.729,9.687 M12,2 C6.478,2 2,6.477 2,12 C2,17.522 6.478,22 12,22 C17.523,22 22,17.522 22,12 C22,6.477 17.523,2 12,2"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.0ebae5edc47d78479f0800953f6e2e18.svg";
export { ForwardRef as ReactComponent };